import React from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import * as serviceWorker from './serviceWorker'
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import BugsnagContext from './context/bugsnag-context'

import App from './App'

const bugsnagClient = bugsnag('d49bd7c5ca2693a13311137f2bb91d1a')
bugsnagClient.use(bugsnagReact, React)
const ErrorBoundary = bugsnagClient.getPlugin('react')

const domNode = document.getElementById('root')
const root = createRoot(domNode)

root.render(
  <ErrorBoundary>
    <BugsnagContext.Provider
      value={{
        bugsnagClient,
      }}
    >
      <App />
    </BugsnagContext.Provider>
  </ErrorBoundary>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
